import React, { useState } from "react";
import ViewWeekOutlinedIcon from "@mui/icons-material/ViewWeekOutlined";
import { Button, Checkbox, FormControlLabel, Popover, Stack, Typography } from "@mui/material";

export type QuotesListColumnVisibility = {
  fulfilment: boolean;
  term: boolean;
  lastUpdated: boolean;
};

export const allColumnsVisible: QuotesListColumnVisibility = { fulfilment: true, term: true, lastUpdated: true };

const columnToggles: { key: keyof QuotesListColumnVisibility; label: string }[] = [
  { key: "fulfilment", label: "Fulfillment" },
  { key: "term", label: "Term" },
  { key: "lastUpdated", label: "Last updated" },
];

export function DisplayPopover({
  visibility,
  onVisibilityChange,
}: {
  visibility: QuotesListColumnVisibility;
  onVisibilityChange: (key: keyof QuotesListColumnVisibility, isVisible: boolean) => void;
}) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  return (
    <>
      <Button
        variant="outlined"
        color="secondary"
        startIcon={<ViewWeekOutlinedIcon />}
        onClick={(event) => setAnchorEl(event.currentTarget)}
      >
        Display
      </Button>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        <Stack sx={{ p: 2, width: 220 }}>
          <Typography variant="overline" color="text.secondary">
            Columns
          </Typography>
          {columnToggles.map((toggle) => (
            <FormControlLabel
              key={toggle.key}
              label={toggle.label}
              control={
                <Checkbox
                  checked={visibility[toggle.key]}
                  onChange={(event) => onVisibilityChange(toggle.key, event.target.checked)}
                />
              }
            />
          ))}
        </Stack>
      </Popover>
    </>
  );
}
